module.exports = __webpack_public_path__ + "img/zhenduan-2_pitchon.de24b20a.svg";